<dynamic-form [fields]="fields" [submitTitle$]="title$" [cancelTitle$]="cancelTitle" [formTitle$]="title$" [entity$]="entity$"
              (submit)="onSubmit($event)" (cancel)="onCancel()">
</dynamic-form>
